import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services';
import { inject } from '@angular/core';

export const permissionGuard = (requiredPermissions: string[]): CanActivateFn => {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    const user = auth.getCurrentUser();

    if (!user) return router.parseUrl('/login');
    if (!auth.hasAnyPermission(requiredPermissions)) return router.parseUrl('/unauthorized');
    return true;
  };
};
